import { Users, Smartphone } from 'lucide-react';

interface EdgeQuickStatsProps {
  fixedClients: number | string;
  mobileDevices: number | string;
}

const EdgeQuickStats = ({ fixedClients, mobileDevices }: EdgeQuickStatsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="card bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-blue-600 mb-1">Edge Peerings</p>
            <p className="text-3xl font-bold text-blue-900">{fixedClients}</p>
            <p className="text-xs text-blue-600 mt-1">Site-to-Site Tunnels</p>
          </div>
          <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center shadow-lg">
            <Users className="w-6 h-6 text-white" />
          </div>
        </div>
      </div>

      <div className="card bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-purple-600 mb-1">Mobile Devices</p>
            <p className="text-3xl font-bold text-purple-900">{mobileDevices}</p>
            <p className="text-xs text-purple-600 mt-1">Connected Clients</p>
          </div>
          <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center shadow-lg">
            <Smartphone className="w-6 h-6 text-white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdgeQuickStats;

